import './BenefitsFootnote.css';const benefitsFootnote__paragraph = "_benefitsFootnote__paragraph_1bz9p_1";
const benefitsFootnote__text = "_benefitsFootnote__text_1bz9p_10";
const styles = {
  benefitsFootnote__paragraph,
  benefitsFootnote__text
};
export {
  benefitsFootnote__paragraph,
  benefitsFootnote__text,
  styles as default
};
